import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { color } from '@coursera/coursera-ui';
import { SvgCheck, SvgInfo, SvgWarning } from '@coursera/coursera-ui/svg';

import 'css!bundles/authoring/common/components/__styles__/ActionExplanation';

type Props = {
  type?: 'clarification' | 'info' | 'warning';
  text: React.ReactNode;
  delimited?: boolean;
};

export const explanationTypes = {
  CLARIFICATION: 'clarification',
  INFO: 'info',
  WARNING: 'warning',
} as const;

const { CLARIFICATION, INFO, WARNING } = explanationTypes;

const ActionExplanation = ({ type = CLARIFICATION, text, delimited = true }: Props) => {
  let icon;
  const iconProps = {
    size: 20,
    color: color.black,
  };

  switch (type) {
    case CLARIFICATION:
      icon = <SvgCheck {...iconProps} />;
      break;
    case WARNING:
      icon = <SvgWarning {...iconProps} color={color.warning} />;
      break;
    case INFO:
    default:
      icon = <SvgInfo {...iconProps} />;
  }

  return (
    <div className={`rc-ActionExplanation ${delimited ? 'delimited' : ''}`}>
      {icon}
      <Typography2 component="p">{text}</Typography2>
    </div>
  );
};

export default ActionExplanation;
